/**
 *  Main
 *
 *  Created by Legman on 19/9/2015.
 *
 */

import Application              from "./Application";
import AudioManager             from "./AudioManager";
import BoomerangPreloaderScene  from "./BoomerangPreloaderScene";
import CNPreloaderScene         from "./CNPreloaderScene";
import Common                   from "./Common";
import Input                    from "./Input";
import isMobile                 from "ismobilejs";

/**
 * @class
 */
export default class Main {
    /**
     * @param {number} width
     * @param {number} height
     */
    constructor(width, height) {
        /**
         * @member {!number}
         * @private
         */
        this._width = width;

        /**
         * @member {!number}
         * @private
         */
        this._height = height;

        /**
         * @member {PreloaderScene}
         * @private
         */
        this._preloader = null;

        /**
         * @member {Application}
         * @private
         */
        this._game = null;
    }

    init() {
        Common.assets   = p3.AssetManager.instance;
        Common.audio    = p3.Button.audio = new AudioManager();
        Common.language = language;

        const params                    = new p3.ViewParams();
        params.holderId                 = "game";
        params.width                    = this._width;
        params.height                   = this._height;
        params.portrait                 = true;
        params.aspectRatioFillHeight    = false;
        params.rotateImageUrl           = "./assets/images/localisation/rotate_" + language + ".jpg";
        params.rotateImageColor         = "#000000";

        PIXI.settings.RETINA_PREFIX = /\_(?=[^_]*$)(.+)x/;

        p3.Device.init(window["bowser"]);

        TweenMax.defaultOverwrite = "none";
        TweenMax.ticker.fps(60);

        const view = new p3.View(params);
        view.signals.ready.addOnce(function(canvas) {
            const options                   = {};
            options.view                    = canvas;
            options.transparent             = false;
            options.antialias               = false;
            options.preserveDrawingBuffer   = false;
            options.resolution              = 1.0;

            const stage     = new PIXI.Container();
            Common.stage    = stage;

            const input = new Input();
            input.init(stage, canvas);
            Common.input = input;

            if (p3.Device.isCocoonJS) {
                stage.scale.x = window.innerHeight / params.height;
                stage.scale.y = window.innerHeight / params.height;
            }

            const renderer = !p3.Device.isCocoonJS ?
                PIXI.autoDetectRenderer(this._width, this._height, options) :
                new PIXI.WebGLRenderer(window.innerWidth, window.innerHeight, options);
            renderer.backgroundColor    = 0x0;
            Common.renderer             = renderer;
            Common.isWebGL              = (renderer instanceof PIXI.WebGLRenderer);

            const scene = new p3.SceneManager(renderer);
            scene.updateAll = true;
            Common.scene = scene;
            Common.stage.addChild(scene.view);

            PIXI.ticker.shared.add(function(deltaTime) {
                window.deltaTime = deltaTime / PIXI.settings.TARGET_FPMS / 1000;

                scene.update();
                renderer.render(Common.stage);
            }, this);

            window.delay = function(callback, delay, scope) {
                return TweenMax.delayedCall(delay, callback, [], scope);
            };
            window.translate = function(str) {
                let s = Common.config.strings[str];
                s = s && s[Common.language];
                return (typeof s !== "undefined") ? s : str;
            };

            this.loadPreloader();
        }, this);
        view.signals.resize.add(this.onCanvasResize, this);
        Common.view = view;
    }

    loadPreloader() {
        let files = [
            {name: "buttons_1x", url: "images/" + "buttons_1x" + ".json"},
            {name: "strings", url: "data/" + "strings" + ".json"},

            {name: "cloudy_bold_60", url: "fonts/" + "cloudy_bold_60" + ".xml"},
            {name: "cloudy_bold_100", url: "fonts/" + "cloudy_bold_100" + ".xml"},
            {name: "cloudy_8bit2_60", url: "fonts/" + "cloudy_8bit2_60" + ".xml"}
        ];

        if (boomerang) {
            files = files.concat([
                {name: "preloader_1x", url: "images/" + "preloader_1x" + ".json"}
            ]);
        } else {
            files = files.concat([
                {name: "cn_preloader", url: "images/" + "cn_preloader" + ".jpg"},
                {name: "cn_preloader_1x", url: "images/" + "cn_preloader_1x" + ".json"}
            ]);
        }

        const sounds = [];
        if (files.length) {
            Common.assets.addFiles(files, "assets/");
            Common.assets.signals.complete.addOnce(function() {
                this.createConfig();
                this.loadAssets();
            }, this);
            Common.assets.load();
        } else {
            this.loadAssets();
        }
    }

    loadAssets() {
        const files = [
            {name: "bg_end", url: "images/" + "bg_end" + ".jpg"},
            {name: "bg_game", url: "images/" + "bg_game" + ".jpg"},
            {name: "bg_intro", url: "images/" + "bg_intro" + ".jpg"},
            {name: "bg_splash", url: "images/" + "bg_splash" + ".jpg"},

            {name: "game_1x", url: "images/" + "game_1x" + ".json"},
            {name: "gradients_1x", url: "images/" + "gradients_1x" + ".json"},
            {name: "intro_1x", url: "images/" + "intro_1x" + ".json"},
            {name: "particles_1x", url: "images/" + "particles_1x" + ".json"},
            {name: "pause_1x", url: "images/" + "pause_1x" + ".json"},
            {name: "results_1x", url: "images/" + "results_1x" + ".json"},
            {name: "tiles_1x", url: "images/" + "tiles_1x" + ".json"},
            {name: "ui_1x", url: "images/" + "ui_1x" + ".json"},
            {name: "title", url: "images/localisation/" + "title_" + language + ".png"},

            {name: "steve", url: "images/" + "steve" + ".json"},

            {name: "replicator_001", url: "particles/" + "replicator_001" + ".json"},
            {name: "end_game_confetti", url: "particles/" + "end_game_confetti" + ".json"},
            {name: "best", url: "particles/" + "best" + ".json"}
        ];
        const sounds = [
            "music_ingame_00",
            "music_mainmenu_screen_00",
            "music_pause_screen_00",
            "music_score_screen_00"
        ];
        const sprite = {
            "silence": [
                0,
                2000,
                true
            ],
            "sfx_ambience_lab_00": [
                3000,
                8192.086167800455
            ],
            "sfx_arm_left_00": [
                13000,
                991.3378684807252
            ],
            "sfx_arm_right_00": [
                15000,
                991.3378684807252
            ],
            "sfx_arm_up_00": [
                17000,
                412.22222222222274
            ],
            "sfx_btn_home_00": [
                19000,
                440.1587301587284
            ],
            "sfx_btn_press_00": [
                21000,
                385.192743764172
            ],
            "sfx_clone_zap_00": [
                23000,
                394.263038548754
            ],
            "sfx_clone_zap_01": [
                25000,
                701.3832199546499
            ],
            "sfx_game_over_00": [
                27000,
                2304.013605442176
            ],
            "sfx_game_play_cpu_intro_00": [
                31000,
                7288.526077097508
            ],
            "sfx_new_highscore_01": [
                40000,
                2714.96598639456
            ],
            "sfx_results_reveal_00": [
                44000,
                2196.5079365079346
            ],
            "sfx_results_reveal_01": [
                48000,
                1303.3333333333346
            ],
            "sfx_results_reveal_02": [
                51000,
                1974.1043083900252
            ],
            "sfx_results_reveal_03": [
                54000,
                1376.1678004535156
            ],
            "sfx_results_reveal_04": [
                57000,
                3753.922902494331
            ],
            "sfx_results_reveal_05": [
                62000,
                2331.156462585028
            ],
            "sfx_steve_00": [
                66000,
                1162.8344671201774
            ],
            "sfx_steve_01": [
                69000,
                866.0317460317515
            ],
            "sfx_steve_can_00": [
                71000,
                566.1904761904708
            ],
            "sfx_steve_fall_scream_00": [
                73000,
                346.87074829932385
            ],
            "sfx_steve_fall_scream_01": [
                75000,
                368.86621315193224
            ],
            "sfx_steve_fall_scream_02": [
                77000,
                433.0385487528332
            ],
            "sfx_steve_fall_scream_03": [
                79000,
                322.1088435374213
            ],
            "sfx_steve_gummybears_00": [
                81000,
                619.2063492063511
            ],
            "sfx_steve_land_normal_00": [
                83000,
                264.1950113378755
            ],
            "sfx_steve_land_normal_01": [
                85000,
                195.66893424035925
            ],
            "sfx_steve_land_normal_02": [
                87000,
                270.8390022675786
            ],
            "sfx_steve_land_normal_03": [
                89000,
                202.04081632653015
            ],
            "sfx_steve_land_normal_04": [
                91000,
                186.43990929705012
            ],
            "sfx_steve_land_perfect_03": [
                93000,
                649.7052154195018
            ],
            "sfx_steve_ouch_00": [
                95000,
                382.6077097505731
            ],
            "sfx_tv_help_static_00": [
                97000,
                216.7120181405835
            ]
        };
        if (files.length) {
            this._preloader = boomerang ? new BoomerangPreloaderScene() : new CNPreloaderScene();
            Common.scene.add(this._preloader);

            Common.assets.addFiles(files, "assets/");
            Common.assets.signals.progress.add(this.onLoadingProgress, this);
            Common.assets.signals.complete.addOnce(this.onLoadingCompleted, this);
            Common.assets.load();

            const extensions = isMobile.android.device ? [".ogg"] : [".m4a", ".mp3", ".ogg"];
            console.log(extensions);
            Common.audio.addSoundSprite("sprite", sprite, extensions, "assets/audio/");
            Common.audio.addSounds(sounds, extensions, "assets/audio/");
        } else {
            this.startGame();
        }
    }

    createConfig() {
        const assets = Common.assets;

        const config = {};
        config.strings = assets.getJSON("strings");
        Common.config = config;
        console.log(config);
    }

    /**
     * @param [t=0]
     */
    startGame(t = 0) {
        delay(function() {
            this._game = new Application();
            this._game.init();
        }, t, this);
    }

    /**
     * @param {Event} event
     */
    onLoadingProgress(event) {
        this._preloader.loaded = event.progress / 100.0;
    }

    onLoadingCompleted() {
        Common.assets.signals.progress.removeAll();
        Common.assets.signals.complete.removeAll();

        this._preloader.loaded = 1;

        if (isMobile.any) {
            this._preloader.signals.next.add(function() {
                this.startGame(0);
            }, this);
        } else {
            this.startGame(1);
        }
    }

    /**
     * @param {boolean} correct
     */
    onCanvasResize(correct) {
        if (correct) {
            Common.renderer.resize(p3.View.width, p3.View.height);
            if (Common.scene) {
                Common.scene.resize();
            }
        }
    }
}
